/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormMessage,
} from "@/shared/components/ui/form";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../ui/input-otp";
import { BaseFieldProps } from "./form-field-utils";
import { FormFieldLabel } from "./form-field-label";

type FieldInputOTPProps =
    BaseFieldProps & {
        /** OTP hanesi (slot sayısı) */
        maxLength?: number;
        /** Slotlar arasında boşluk için */
        gapClassName?: string;
        /** Slotlar için */
        slotClassName?: string;
        /** OTP değer değiştiğinde tetiklenir */
        onValueChange?: (value: string) => void;
    } & Omit<
        React.ComponentProps<typeof InputOTP>,
        // Bu bileşende children'ı biz oluşturuyoruz, render'ı da kullanmıyoruz
        "children" | "render" | "maxLength" | "value" | "defaultValue" | "onChange"
    >;

export function FieldInputOTP({
    name,
    label,
    description,
    className,
    labelType = "text",
    tooltipContent,
    gapClassName,
    slotClassName,
    maxLength = 6,
    onValueChange,
    ...rest
}: FieldInputOTPProps) {
    return (
        <FormField
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormFieldLabel label={label} labelType={labelType} tooltipContent={tooltipContent} />
                    <FormControl>
                        <InputOTP
                            value={field.value ?? ""}
                            onChange={(val: string) => {
                                field.onChange(val)
                                onValueChange?.(val)
                            }}
                            onBlur={field.onBlur}
                            name={field.name}
                            ref={field.ref}
                            autoFocus
                            // shadcn/input-otp propları
                            maxLength={maxLength}
                            {...rest}
                        >
                            <InputOTPGroup className={gapClassName}>
                                {Array.from({ length: maxLength }).map((_, i) => (
                                    <InputOTPSlot key={i} index={i} className={slotClassName} />
                                ))}
                            </InputOTPGroup>
                        </InputOTP>
                    </FormControl>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
